module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-99b9c866.png";